export default "__VITE_ASSET__CWFwYqyK__"